/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Use_Cases_Launch_DescriptionInputs */

const en_directory_taxonomy_use_cases_launch_description = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Launch_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse the directory before publishing and promoting your own launch.`)
};

const zh_directory_taxonomy_use_cases_launch_description = /** @type {(inputs: Directory_Taxonomy_Use_Cases_Launch_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在发布和推广自己的产品前，先浏览现有目录。`)
};

/**
* | output |
* | --- |
* | "Browse the directory before publishing and promoting your own launch." |
*
* @param {Directory_Taxonomy_Use_Cases_Launch_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_use_cases_launch_description = /** @type {((inputs?: Directory_Taxonomy_Use_Cases_Launch_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Use_Cases_Launch_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_use_cases_launch_description(inputs)
	return zh_directory_taxonomy_use_cases_launch_description(inputs)
});
export { directory_taxonomy_use_cases_launch_description as "directory.taxonomy.use-cases.launch.description" }